module.exports = __webpack_public_path__ + "img/Group60.1b899476.png";